import maInputSelect from '@/components/input/modules/select'
import maInputFile from '@/components/input/modules/file'

export default {
  name: 'formImport',

  data: function () {
    return {
      formFilter: null,
      formFile: null
    }
  },

  props: {
    filterFormOptions: {
      type: Array
    },

    mimetypeAccepted: {
      type: String
    },

    isLoading: {
      type: Boolean,
      default: false
    }
  },

  components: {
    maInputSelect,
    maInputFile
  },

  methods: {
    handleSelectFilterChange (event) {
      this.formFilter = event
      this.$emit('onHandleImportFilterChange', this.formFilter)
    },

    handleFormFileUpload (event) {
      this.formFile = event
      this.$emit('onHandleImportFileUpload', this.formFile)
    },

    handleFormFileDelete () {
      this.formFile = null
      this.$emit('onHandleImportFileDelete', null)
    },

    handleImportFormClick () {
      this.$emit('onHandleImportFormClick')
    },

    resetData () {
      this.formFilter = null
      this.formFile = null
      this.$emit('onHandleResetImportData')
    }
  }
}
